const FetaureListingActionType = {
    FEATURELISTING_REQUEST:'FEATURELISTING_REQUEST',
    FEATURELISTING_SUCCESS:'FEATURELISTING_SUCCESS',
    FEATURELISTING_FAIL:'FEATURELISTING_FAIL',
}


export default FetaureListingActionType